import { gql } from "apollo-angular";
import { BASEMODEL_FRAGMENT } from "./base-definition";
import { DELETION_RESPONSE_FRAGMENT } from "./system-definition";

export const TAXONOMY_CATEGORY_FIELDS_FRAGMENT = gql`
fragment TaxonomyCategoryFields on TaxonomyCategory {
    ...IBaseModel
    referenceId
    description
    parentId
}
${BASEMODEL_FRAGMENT}
`;

export const TAXONOMY_CATEGORY_FRAGMENT = gql`
fragment TaxonomyCategory on TaxonomyCategory {
    ...TaxonomyCategoryFields
}
${TAXONOMY_CATEGORY_FIELDS_FRAGMENT}
`;

export const GET_TAXONOMY_CATEGORIES = gql`
query GetTaxonomyCategories($input: SearchInput) {
    getTaxonomyCategories(input: $input) {
        totalItems
        items {
            ...TaxonomyCategory
        }
    }
}
${TAXONOMY_CATEGORY_FRAGMENT}
`;

export const GET_TAXONOMY_CATEGORY = gql`
query GetTaxonomyCategory($id: String!) {
    getTaxonomyCategory(id: $id) {
        ...TaxonomyCategory
    }
}
${TAXONOMY_CATEGORY_FRAGMENT}
`;

export const SAVE_TAXONOMY_CATEGORY = gql`
mutation SaveTaxonomyCategory($input: TaxonomyCategoryInput!) {
    saveTaxonomyCategory(input: $input) {
        ...TaxonomyCategory
    }
}
${TAXONOMY_CATEGORY_FRAGMENT}
`;

export const DELETE_TAXONOMY_CATEGORY = gql`
mutation DeleteTaxonomyCategory($id: String!) {
    deleteTaxonomyCategory(id: $id) {
        ...DeletionResponse
    }
}
${DELETION_RESPONSE_FRAGMENT}
`;
